import mutations from './mutations'
import users from '@/api/users'
import { notify } from '@/utils/error'
import { arrayToObject } from '@/utils/object'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'users'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    loadUsersPerHeader ({ state, commit }, headers) {
      return new Promise((resolve, reject) => {
        users.getAllPerHeaders(headers)
          .then((response) => {
            state.items = arrayToObject(response.data.items)
            resolve(response)
          })
      })
    },
    savePassword (context, { data, userId }) {
      return new Promise((resolve, reject) => {
        users.savePassword({ data, userId })
          .then(() => resolve())
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    savePin (context, { data, userId }) {
      return new Promise((resolve, reject) => {
        users.savePin({ data, userId })
          .then(() => resolve())
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
